import { lazy, Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import { Spinner } from '@/components/Spinner';
import { PasswordGate } from '@/features/socialMedia/PasswordGate';

import { AppShell } from './layout/AppShell';

// Pages are lazy-loaded so the initial bundle is small.
const DashboardPage = lazy(() => import('@/pages/DashboardPage'));
const AssetsPage = lazy(() => import('@/pages/AssetsPage'));
const AssetEditPage = lazy(() => import('@/pages/AssetEditPage'));
const InsightsPage = lazy(() => import('@/pages/InsightsPage'));
const RentvestPage = lazy(() => import('@/pages/RentVsBuyPage'));
const FirePage = lazy(() => import('@/pages/FirePage'));
const RebalancePage = lazy(() => import('@/pages/RebalancePage'));
const SocialMediaPage = lazy(() => import('@/pages/SocialMediaPage'));
const NotFoundPage = lazy(() => import('@/pages/NotFoundPage'));

const FullScreenSpinner = () => (
  <div className="flex min-h-dvh items-center justify-center bg-warm-white text-accent">
    <Spinner size="lg" />
  </div>
);

/** Application route table. All routes are public except `/social-media`,
 *  which sits behind a simple password gate. */
const AppRouter = () => {
  return (
    <Suspense fallback={<FullScreenSpinner />}>
      <Routes>
        <Route element={<AppShell />}>
          <Route index element={<DashboardPage />} />
          <Route path="/assets" element={<AssetsPage />} />
          <Route path="/assets/new" element={<AssetEditPage />} />
          <Route path="/assets/:id/edit" element={<AssetEditPage />} />
          <Route path="/insights" element={<InsightsPage />} />
          <Route path="/rentvest" element={<RentvestPage />} />
          <Route path="/fire" element={<FirePage />} />
          <Route path="/rebalance" element={<RebalancePage />} />
          <Route
            path="/social-media"
            element={
              <PasswordGate>
                <SocialMediaPage />
              </PasswordGate>
            }
          />
          {/* Redirect old auth routes */}
          <Route path="/sign-in" element={<Navigate to="/" replace />} />
          <Route path="/sign-up" element={<Navigate to="/" replace />} />
          <Route path="/reset-password" element={<Navigate to="/" replace />} />
        </Route>
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </Suspense>
  );
};

export default AppRouter;
